import { timingFunctionMap } from './scrollTo';

const timingFunction = 'ease-out';

export function scrollToForIOS12IframeHack(element: HTMLElement) {
  const iOS12IframeHackWrapper = document.querySelector(
    '#iOS12IframeHackWrapper'
  );

  const speed = iOS12IframeHackWrapper!.scrollHeight / 0.75;

  const scrollTargetY = element.offsetTop;
  const scrollY = iOS12IframeHackWrapper!.scrollTop;
  let currentTime = 0;
  // min time .1, max time .8 seconds
  const time = Math.max(
    0.1,
    Math.min(Math.abs(scrollY - scrollTargetY) / speed, 0.8)
  );

  // add animation loop
  function step() {
    currentTime += 1 / 60;
    const p = currentTime / time;
    const t = timingFunctionMap[timingFunction](p);
    if (p < 1) {
      requestAnimationFrame(step);
      iOS12IframeHackWrapper!.scrollTo(
        0,
        scrollY + (scrollTargetY - scrollY) * t
      );
    } else {
      iOS12IframeHackWrapper!.scrollTo(0, scrollTargetY);
    }
  }

  /**
   * called to start.
   */
  step();
}
